import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this._outsideClickHandler = this._handleOutsideClick.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this._outsideClickHandler)
  }

  toggle(event) {
    event.stopPropagation()
    const isHidden = this.menuTarget.classList.contains("hidden")
    if (isHidden) {
      this.menuTarget.classList.remove("hidden")
      document.addEventListener("click", this._outsideClickHandler)
    } else {
      this._close()
    }
  }

  _handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this._close()
    }
  }

  _close() {
    this.menuTarget.classList.add("hidden")
    document.removeEventListener("click", this._outsideClickHandler)
  }
}
